var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 39416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 13.5385C16 14.1913 15.7407 14.8174 15.279 15.279C14.8174 15.7407 14.1913 16 13.5385 16H2.46154C1.8087 16 1.1826 15.7407 0.720968 15.279C0.25934 14.8174 0 14.1913 0 13.5385V2.46154C0 1.8087 0.25934 1.1826 0.720968 0.720968C1.1826 0.25934 1.8087 0 2.46154 0H13.5385C14.1913 0 14.8174 0.25934 15.279 0.720968C15.7407 1.1826 16 1.8087 16 2.46154V13.5385Z",
    fill: "#D32D27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3073 6.80812H9.23036V3.7312H6.76882V6.80812H3.69189V9.23089H6.76882V12.3466H9.23036V9.23089H12.3073V6.80812Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.c4c4275fdd2afd0b063ae6f3351418d1.svg";
export { ForwardRef as ReactComponent };